import { Link } from 'react-router-dom';

import { PageMeta } from '@/components/PageMeta';
import { ROUTES } from '@/config/routes';
import { CalendarX } from 'lucide-react';

export default function InscriptionsFermees() {
  return (
    <section className='px-6 pb-20 pt-40'>
      <PageMeta title='Inscriptions fermées' robots='noindex, nofollow' />
      <div className='mx-auto max-w-2xl text-center'>
        <div className='mb-6 flex justify-center'>
          <div className='flex h-20 w-20 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800'>
            <CalendarX className='h-10 w-10 text-slate-500 dark:text-slate-400' />
          </div>
        </div>

        <h1 className='mb-4 text-3xl font-extrabold text-slate-900 dark:text-slate-100'>Inscriptions fermées</h1>
        <p className='mb-8 text-lg text-slate-500 dark:text-slate-400'>
          Les inscriptions sont actuellement fermées, revenez bientôt.
        </p>

        <Link
          to={ROUTES.HOME}
          className='inline-flex items-center gap-2 rounded-2xl bg-blue-600 px-8 py-3 font-bold text-white transition hover:bg-blue-700'
        >
          Retour à l'accueil
        </Link>
      </div>
    </section>
  );
}
